import type { IZona } from "./entidades/IZona";
import type { IRespuestaApiLista, IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";

export class ZonaModelo {
    constructor() { }
    public async obtenerListaZonas(): Promise<IRespuestaApiLista<IZona>> {
        const { data } = await api.get(
            `/api/Zonas/Listar`, {
            headers: {
                "Content-Type": "application/json"
            },
        });
        return data;
    }

    public async crearZona(Zona: IZona): Promise<IRespuestaApiObjeto<IZona>> {
        const { data } = await api.post(
            `/api/Zonas/Crear`, Zona, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async editarZona(Zona: IZona): Promise<IRespuestaApiObjeto<IZona>> {
        const { data } = await api.put(
            `/api/Zonas/Actualizar`, Zona, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async eliminarZona(Zona: IZona): Promise<IRespuestaApiObjeto<IZona>> {
        const { data } = await api.delete(
            `/api/Zonas/Actualizar/${Zona.Id}`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

}
